import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { drainer, relireFile, surLivraison } from './etat-file'

// Draineur de la file d'envoi (porté de flowAI) : relancé au montage, au retour du réseau,
// quand l'appli revient au premier plan et toutes les 20 secondes, et à l'heure du prochain
// essai automatique. Sans rendu. Monté une fois pour tout l'espace connecté.

const INTERVALLE_MS = 20_000

export function PiloteFileEnvoi(): null {
  const client = useQueryClient()
  useEffect(() => {
    let fini = false
    let minuteurEssai: number | null = null
    const passer = async () => {
      if (fini) return
      const bilan = await drainer()
      if (minuteurEssai !== null) window.clearTimeout(minuteurEssai)
      minuteurEssai = null
      if (bilan.prochainEssai !== undefined && !fini) {
        const dans = Math.max(1000, bilan.prochainEssai - Date.now())
        if (dans < INTERVALLE_MS) minuteurEssai = window.setTimeout(() => void passer(), dans)
      }
    }
    // Un envoi livré (par ce pilote ou par la page photo) : « Mes envois » se met à jour.
    const desabonner = surLivraison(() => void client.invalidateQueries({ queryKey: ['envois'] }))
    void relireFile().then(passer)
    const auPremierPlan = () => {
      if (document.visibilityState === 'visible') void passer()
    }
    window.addEventListener('online', passer)
    document.addEventListener('visibilitychange', auPremierPlan)
    const intervalle = window.setInterval(() => void passer(), INTERVALLE_MS)
    return () => {
      fini = true
      desabonner()
      window.removeEventListener('online', passer)
      document.removeEventListener('visibilitychange', auPremierPlan)
      window.clearInterval(intervalle)
      if (minuteurEssai !== null) window.clearTimeout(minuteurEssai)
    }
  }, [client])
  return null
}
